"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Func_y_x_out = exports.Method_a_axis_ddof_keepdims = exports.Func_a_axis_ddof_keepdims = exports.Method_a_ord_axis_keepdims = exports.Func_a_ord_axis_keepdims = exports.Method_a_axis_keepdims = exports.Func_a_axis_keepdims = exports.Method_values_where = exports.Func_a_values_where = exports.Method_other_out = exports.Func_a_other_out = exports.Method_a_decimals_out = exports.Func_a_decimals_out = exports.Method_out = exports.Func_a_out = exports.Func_a_lastAxis = exports.Func_a_q_axis = exports.kwargs_decorator = void 0;
var _globals_1 = require("./_globals");
function kwargs_decorator(_a) {
    var defaults = _a.defaults, implementation = _a.implementation, parsers = _a.parsers, this_as_first_arg = _a.this_as_first_arg;
    var kwParser = kwargs_parser.apply(void 0, __spreadArray([defaults], __read(parsers), false));
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        //@ts-ignore
        if (this_as_first_arg)
            args = __spreadArray([this], __read(args), false);
        var parsedArgs = kwParser(args);
        var out = implementation.apply(void 0, __spreadArray([], __read(parsedArgs), false));
        if ((0, _globals_1.isarray)(out) && out.shape.length == 0)
            return out.flat[0];
        return out;
    });
}
exports.kwargs_decorator = kwargs_decorator;
function kwargs_parser(defaults) {
    var parsers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        parsers[_i - 1] = arguments[_i];
    }
    var spreadKey = null;
    var last = defaults.length && defaults.slice(-1)[0];
    if (last && last[0].startsWith('...')) {
        spreadKey = last[0] = last[0].slice(3);
    }
    var defaultsDict = Object.assign(Object.fromEntries(defaults));
    var validKwargsNames = Object.fromEntries(defaults.map(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return [key, true];
    }));
    var shorten = function (s) {
        s = JSON.stringify(s);
        // s = s.toString();
        return s.length > 100 ? s.slice(0, 100) + '...' : s;
    };
    return function (args) {
        var e_1, _a;
        var kwargs = {};
        if (spreadKey)
            kwargs[spreadKey] = __spreadArray([], __read(defaultsDict[spreadKey]), false); // copy
        for (var i = 0; i < args.length; i++) {
            var value = args[i];
            if (value instanceof Object && !(0, _globals_1.isarray)(value) && !Array.isArray(value)) {
                for (var key in value) {
                    if (key == spreadKey)
                        kwargs[key].push(value[key]);
                    else {
                        if (key in kwargs)
                            throw new Error("Duplicate argument ".concat(key, " in ").concat(shorten(args)));
                        if (!validKwargsNames[key])
                            throw new Error("Invalid argument ".concat(key, " in ").concat(shorten(args)));
                        kwargs[key] = value[key];
                    }
                }
            }
            else if (value !== undefined) {
                if (spreadKey && i >= defaults.length - 1)
                    kwargs[spreadKey].push(value);
                else if (i < defaults.length) {
                    var key = defaults[i][0];
                    if (key in kwargs)
                        throw new Error("Duplicate argument ".concat(key, " in ").concat(shorten(args)));
                    if (!validKwargsNames[key])
                        throw new Error("Invalid argument ".concat(key, " in ").concat(shorten(args)));
                    kwargs[key] = value;
                }
                else
                    throw new Error("Too many arguments ".concat(shorten(args)));
            }
        }
        for (var key in defaultsDict) {
            if (!(key in kwargs))
                kwargs[key] = defaultsDict[key];
            if (kwargs[key] === undefined) {
                throw new Error("Missing argument ".concat(key, " in ").concat(shorten(args), ". Found only ").concat(JSON.stringify(Object.keys(args))));
            }
        }
        try {
            for (var parsers_1 = __values(parsers), parsers_1_1 = parsers_1.next(); !parsers_1_1.done; parsers_1_1 = parsers_1.next()) {
                var parser = parsers_1_1.value;
                parser(kwargs);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parsers_1_1 && !parsers_1_1.done && (_a = parsers_1.return)) _a.call(parsers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var sortedArgs = defaults.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return kwargs[key];
        });
        return sortedArgs;
    };
}
var frequently_used_parsers = {
    'a': function (kwargs) { kwargs.a = (0, _globals_1.asarray)(kwargs.a); },
    'a_axis': function (kwargs) {
        kwargs.a = (0, _globals_1.asarray)(kwargs.a);
        if (kwargs.axis == null) {
            kwargs.axis = -1;
        }
        var ndims = kwargs.a.shape.length;
        if (kwargs.axis + ndims < 0 || kwargs.axis >= ndims) {
            throw new Error("Invalid axis ".concat(kwargs.axis, " for array of shape ").concat(JSON.stringify(kwargs.a.shape)));
        }
        if (kwargs.axis < 0) {
            kwargs.axis += ndims;
        }
    },
    'a_axis_flatten': function (kwargs) {
        kwargs.a = (0, _globals_1.asarray)(kwargs.a);
        if (kwargs.axis == null) {
            // flatten
            kwargs.a = kwargs.a.reshape(-1);
            kwargs.axis = -1;
        }
        var ndims = kwargs.a.shape.length;
        if (kwargs.axis + ndims < 0 || kwargs.axis >= ndims) {
            throw new Error("Invalid axis ".concat(kwargs.axis, " for array of shape ").concat(JSON.stringify(kwargs.a.shape)));
        }
        if (kwargs.axis < 0) {
            kwargs.axis += ndims;
        }
    },
    'keepdims': function (kwargs) { kwargs.keepdims = !!kwargs.keepdims; },
    'isarray_or_null': function (key) { return function (kwargs) {
        if (kwargs[key] != null && !(0, _globals_1.isarray)(kwargs[key])) {
            throw new Error("Invalid \"".concat(key, "\" argument. Expected NDArray. Found type ").concat(typeof kwargs[key], " (").concat(kwargs[key].prototype, ")"));
        }
    }; },
    'asarray': function (key) { return function (kwargs) {
        kwargs[key] = (0, _globals_1.asarray)(kwargs[key]);
    }; },
    'isarray': function (key) { return function (kwargs) {
        if (!(0, _globals_1.isarray)(kwargs[key])) {
            throw new Error("Invalid \"".concat(key, "\" argument. Expected NDArray. Found type ").concat(typeof kwargs[key], " (").concat(kwargs[key].prototype, ")"));
        }
    }; },
    'is_integer_non_neg': function (key) { return function (kwargs) {
        if (typeof kwargs[key] !== 'number' || kwargs[key] < 0 || kwargs[key] % 1 !== 0) {
            throw new Error("Invalid \"".concat(key, "\" argument. Expected non-negative integer. Found ").concat(kwargs[key]));
        }
    }; },
    'is_pnorm': function (key) { return function (kwargs) {
        if (typeof kwargs[key] !== 'number' || kwargs[key] <= 0) {
            throw new Error("Invalid \"".concat(key, "\" argument. Expected non-negative integer. Found ").concat(kwargs[key]));
        }
    }; }
};
// Used in statistics.ts:
var Func_a_q_axis;
(function (Func_a_q_axis) {
    Func_a_q_axis.decorator = (kwargs_decorator);
    Func_a_q_axis.defaults = [["a", undefined], ["q", undefined], ["axis", null]];
    Func_a_q_axis.parsers = [
        frequently_used_parsers.a_axis_flatten,
        function (kwargs) { kwargs.q = (0, _globals_1.asarray)(kwargs.q); },
    ];
    Func_a_q_axis.defaultDecorator = function (implementation) { return Func_a_q_axis.decorator({
        defaults: Func_a_q_axis.defaults,
        implementation: implementation,
        parsers: Func_a_q_axis.parsers
    }); };
})(Func_a_q_axis || (exports.Func_a_q_axis = Func_a_q_axis = {}));
// Used by sort:
var Func_a_lastAxis;
(function (Func_a_lastAxis) {
    Func_a_lastAxis.decorator = (kwargs_decorator);
    Func_a_lastAxis.defaults = [["a", undefined], ["axis", -1]];
    Func_a_lastAxis.parsers = [
        frequently_used_parsers['a_axis'],
    ];
    Func_a_lastAxis.defaultDecorator = function (implementation) { return Func_a_lastAxis.decorator({
        defaults: Func_a_lastAxis.defaults,
        implementation: implementation,
        parsers: Func_a_lastAxis.parsers
    }); };
})(Func_a_lastAxis || (exports.Func_a_lastAxis = Func_a_lastAxis = {}));
// Used by elementwise operators and methods:
var Func_a_out;
(function (Func_a_out) {
    Func_a_out.decorator = (kwargs_decorator);
    Func_a_out.defaults = [["a", undefined], ["out", null]];
    Func_a_out.parsers = [
        frequently_used_parsers.asarray('a'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    Func_a_out.defaultDecorator = function (implementation) { return Func_a_out.decorator({
        defaults: Func_a_out.defaults,
        implementation: implementation,
        parsers: Func_a_out.parsers
    }); };
})(Func_a_out || (exports.Func_a_out = Func_a_out = {}));
var Method_out;
(function (Method_out) {
    Method_out.defaults = [["a", undefined], ["out", null]];
    Method_out.parsers = [
        frequently_used_parsers.isarray('a'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Method_out.defaults,
            implementation: implementation,
            parsers: Method_out.parsers,
            this_as_first_arg: true,
        });
    }
    Method_out.defaultDecorator = defaultDecorator;
})(Method_out || (exports.Method_out = Method_out = {}));
// Used by round
var Func_a_decimals_out;
(function (Func_a_decimals_out) {
    Func_a_decimals_out.decorator = (kwargs_decorator);
    Func_a_decimals_out.defaults = [["a", undefined], ["decimals", 0], ["out", null]];
    Func_a_decimals_out.parsers = [
        frequently_used_parsers.asarray('a'),
        frequently_used_parsers.is_integer_non_neg('decimals'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    Func_a_decimals_out.defaultDecorator = function (implementation) { return Func_a_decimals_out.decorator({
        defaults: Func_a_decimals_out.defaults,
        implementation: implementation,
        parsers: Func_a_decimals_out.parsers
    }); };
})(Func_a_decimals_out || (exports.Func_a_decimals_out = Func_a_decimals_out = {}));
var Method_a_decimals_out;
(function (Method_a_decimals_out) {
    Method_a_decimals_out.decorator = (kwargs_decorator);
    Method_a_decimals_out.defaults = [["a", undefined], ["decimals", 0], ["out", null]];
    Method_a_decimals_out.parsers = [
        frequently_used_parsers.isarray('a'),
        frequently_used_parsers.is_integer_non_neg('decimals'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    Method_a_decimals_out.defaultDecorator = function (implementation) { return Method_a_decimals_out.decorator({
        defaults: Method_a_decimals_out.defaults,
        implementation: implementation,
        parsers: Method_a_decimals_out.parsers,
        this_as_first_arg: true,
    }); };
})(Method_a_decimals_out || (exports.Method_a_decimals_out = Method_a_decimals_out = {}));
// Used by binary operators and methods:
var Func_a_other_out;
(function (Func_a_other_out) {
    Func_a_other_out.decorator = (kwargs_decorator);
    Func_a_other_out.defaults = [["a", undefined], ["other", undefined], ["out", null]];
    Func_a_other_out.parsers = [
        frequently_used_parsers.asarray('a'),
        frequently_used_parsers.asarray('other'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    Func_a_other_out.defaultDecorator = function (implementation) { return Func_a_other_out.decorator({
        defaults: Func_a_other_out.defaults,
        implementation: implementation,
        parsers: Func_a_other_out.parsers
    }); };
})(Func_a_other_out || (exports.Func_a_other_out = Func_a_other_out = {}));
var Method_other_out;
(function (Method_other_out) {
    Method_other_out.defaults = [["a", undefined], ["other", undefined], ["out", null]];
    Method_other_out.parsers = [
        frequently_used_parsers.isarray('a'),
        frequently_used_parsers.asarray('other'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Method_other_out.defaults,
            implementation: implementation,
            parsers: Method_other_out.parsers,
            this_as_first_arg: true,
        });
    }
    Method_other_out.defaultDecorator = defaultDecorator;
})(Method_other_out || (exports.Method_other_out = Method_other_out = {}));
// Used by assign operators and methods:
var Func_a_values_where;
(function (Func_a_values_where) {
    Func_a_values_where.decorator = (kwargs_decorator);
    Func_a_values_where.defaults = [["a", undefined], ["values", undefined], ["...where", null]];
    Func_a_values_where.parsers = [
        frequently_used_parsers.asarray('a'),
        frequently_used_parsers.asarray('values'),
    ];
    Func_a_values_where.defaultDecorator = function (implementation) { return Func_a_values_where.decorator({
        defaults: Func_a_values_where.defaults,
        implementation: implementation,
        parsers: Func_a_values_where.parsers
    }); };
})(Func_a_values_where || (exports.Func_a_values_where = Func_a_values_where = {}));
var Method_values_where;
(function (Method_values_where) {
    Method_values_where.decorator = (kwargs_decorator);
    Method_values_where.defaults = [["a", undefined], ["values", undefined], ["...where", null]];
    Method_values_where.parsers = [
        frequently_used_parsers.isarray('a'),
        frequently_used_parsers.asarray('values'),
    ];
    Method_values_where.defaultDecorator = function (implementation) { return Method_values_where.decorator({
        defaults: Method_values_where.defaults,
        implementation: implementation,
        parsers: Method_values_where.parsers,
        this_as_first_arg: true,
    }); };
})(Method_values_where || (exports.Method_values_where = Method_values_where = {}));
// Used by reduce functions and methods:
var Func_a_axis_keepdims;
(function (Func_a_axis_keepdims) {
    Func_a_axis_keepdims.decorator = (kwargs_decorator);
    Func_a_axis_keepdims.defaults = [["a", undefined], ["axis", null], ["keepdims", false]];
    Func_a_axis_keepdims.parsers = [
        frequently_used_parsers.a_axis_flatten,
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Func_a_axis_keepdims.defaults,
            implementation: implementation,
            parsers: Func_a_axis_keepdims.parsers
        });
    }
    Func_a_axis_keepdims.defaultDecorator = defaultDecorator;
})(Func_a_axis_keepdims || (exports.Func_a_axis_keepdims = Func_a_axis_keepdims = {}));
var Method_a_axis_keepdims;
(function (Method_a_axis_keepdims) {
    Method_a_axis_keepdims.decorator = (kwargs_decorator);
    Method_a_axis_keepdims.defaults = [["a", undefined], ["axis", null], ["keepdims", false]];
    Method_a_axis_keepdims.parsers = [
        frequently_used_parsers.isarray('a'),
        frequently_used_parsers.a_axis_flatten,
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Method_a_axis_keepdims.defaults,
            implementation: implementation,
            parsers: Method_a_axis_keepdims.parsers,
            this_as_first_arg: true,
        });
    }
    Method_a_axis_keepdims.defaultDecorator = defaultDecorator;
})(Method_a_axis_keepdims || (exports.Method_a_axis_keepdims = Method_a_axis_keepdims = {}));
// For norm:
var Func_a_ord_axis_keepdims;
(function (Func_a_ord_axis_keepdims) {
    Func_a_ord_axis_keepdims.decorator = (kwargs_decorator);
    Func_a_ord_axis_keepdims.defaults = [["a", undefined], ["ord", 2], ["axis", null], ["keepdims", false]];
    Func_a_ord_axis_keepdims.parsers = [
        frequently_used_parsers.a_axis_flatten,
        frequently_used_parsers.is_pnorm('ord'),
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Func_a_ord_axis_keepdims.defaults,
            implementation: implementation,
            parsers: Func_a_ord_axis_keepdims.parsers,
        });
    }
    Func_a_ord_axis_keepdims.defaultDecorator = defaultDecorator;
})(Func_a_ord_axis_keepdims || (exports.Func_a_ord_axis_keepdims = Func_a_ord_axis_keepdims = {}));
var Method_a_ord_axis_keepdims;
(function (Method_a_ord_axis_keepdims) {
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Func_a_ord_axis_keepdims.defaults,
            parsers: Func_a_ord_axis_keepdims.parsers,
            implementation: implementation,
            this_as_first_arg: true,
        });
    }
    Method_a_ord_axis_keepdims.defaultDecorator = defaultDecorator;
})(Method_a_ord_axis_keepdims || (exports.Method_a_ord_axis_keepdims = Method_a_ord_axis_keepdims = {}));
// For std:
var Func_a_axis_ddof_keepdims;
(function (Func_a_axis_ddof_keepdims) {
    Func_a_axis_ddof_keepdims.decorator = (kwargs_decorator);
    Func_a_axis_ddof_keepdims.defaults = [["a", undefined], ["ddof", 0], ["axis", null], ["keepdims", false]];
    Func_a_axis_ddof_keepdims.parsers = [
        frequently_used_parsers.a_axis_flatten,
        frequently_used_parsers.is_integer_non_neg('ddof'),
    ];
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Func_a_axis_ddof_keepdims.defaults,
            implementation: implementation,
            parsers: Func_a_axis_ddof_keepdims.parsers,
        });
    }
    Func_a_axis_ddof_keepdims.defaultDecorator = defaultDecorator;
})(Func_a_axis_ddof_keepdims || (exports.Func_a_axis_ddof_keepdims = Func_a_axis_ddof_keepdims = {}));
var Method_a_axis_ddof_keepdims;
(function (Method_a_axis_ddof_keepdims) {
    function defaultDecorator(implementation) {
        return kwargs_decorator({
            defaults: Func_a_axis_ddof_keepdims.defaults,
            parsers: Func_a_axis_ddof_keepdims.parsers,
            implementation: implementation,
            this_as_first_arg: true,
        });
    }
    Method_a_axis_ddof_keepdims.defaultDecorator = defaultDecorator;
})(Method_a_axis_ddof_keepdims || (exports.Method_a_axis_ddof_keepdims = Method_a_axis_ddof_keepdims = {}));
// Used by atan2:
var Func_y_x_out;
(function (Func_y_x_out) {
    Func_y_x_out.decorator = (kwargs_decorator);
    Func_y_x_out.defaults = [["x", undefined], ["y", undefined], ["out", null]];
    Func_y_x_out.parsers = [
        frequently_used_parsers.asarray('x'),
        frequently_used_parsers.asarray('y'),
        frequently_used_parsers.isarray_or_null('out'),
    ];
    Func_y_x_out.defaultDecorator = function (implementation) { return Func_y_x_out.decorator({
        defaults: Func_y_x_out.defaults,
        implementation: implementation,
        parsers: Func_y_x_out.parsers
    }); };
})(Func_y_x_out || (exports.Func_y_x_out = Func_y_x_out = {}));
